// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"240":"aecfe591","599":"aecfe591"}[chunkId] + ".css";
};